import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../container/context";
// import api from "../../../services/api";
import comunidade from "../../../services/comunidade";
import Form from "../../../components/form";
import { formatDateTime, formatToCurrency } from "../../../helpers/helpers";
import ActionTable from "../../../components/table/ActionTable";
import { Box, Button, Grid, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const listaSituacao = [
  { id: 1, nome: "Em andamento" },
  { id: 2, nome: "Aguardando pagamento" },
  { id: 3, nome: "Enviado" },
  { id: 4, nome: "Cancelado" },
  { id: 5, nome: "Expirado" },
];

export default function Pedido(props) {
  const history = props.history;
  const [id] = useState(props.match.params.id);
  const [pedido, setPedido] = useState({});
  const [endereco, setEndereco] = useState({});
  const [itens, setItens] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [inserindoEvento, setInserindoEvento] = useState(false);
  const [evento, setEvento] = useState({});
  const { notification, confirm } = useContext(AppContext);
  const [dadosEventos, setDadosEventos] = useState({ tipo: 0 });

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    comunidade
      .get("admin/pedidos/carregar", { id: id })
      .then((res) => {
        console.log("pedido", res);
        res.valorTotalFormat = formatToCurrency(res.valorTotal);
        res.responsavel = `${res.usuarioNome} (${res.usuarioEmail})`;
        res.data = formatDateTime(res.registro, "D/M/Y h:m");
        res.status =
          listaSituacao.find((situacao) => situacao.id === res.situacao)
            ?.nome || "Situação não encontrada";

        setPedido(res);

        res.itens.forEach((item) => {
          item.valorFormat = formatToCurrency(item.valorUnitarioCentavos);
        });

        res.eventos.forEach((evento) => {
          evento.registro = formatDateTime(evento.registro, "D/M/Y h:m");
        });

        setItens(res.itens);
        setEndereco(res.enderecoEntrega);
        setEventos(res.eventos);
      })
      .catch((err) => {
        console.log("err", err);
        notification("error", "Erro ao carregar pedido");
      });
  };

  const fDados = {
    title: "Dados do pedido",
    form: {
      codigo: {
        label: "Código",
        type: "text",
        space: 6,
        value: pedido.codigo,
        readOnly: true,
      },
      data: {
        label: "Data/hora",
        type: "text",
        space: 6,
        value: pedido.data,
        readOnly: true,
      },
      valorTotal: {
        label: "Valor total",
        type: "text",
        space: 6,
        value: pedido.valorTotalFormat,
        readOnly: true,
      },
      situacao: {
        label: "Situação",
        type: "text",
        space: 6,
        value: pedido.status,
        readOnly: true,
      },
    },
  };

  const fResponsavel = {
    title: "Responsável",
    form: {
      codigo: {
        label: "Nome",
        type: "text",
        space: 12,
        value: pedido.usuarioNome,
        readOnly: true,
      },
      data: {
        label: "CPF",
        type: "text",
        space: 4,
        value: pedido.usuarioCPF,
        readOnly: true,
      },
      valorTotal: {
        label: "Email",
        type: "text",
        space: 4,
        value: pedido.usuarioEmail,
        readOnly: true,
      },
      situacao: {
        label: "Telefone",
        type: "text",
        space: 4,
        value: pedido.usuarioTelefone,
        readOnly: true,
      },
    },
  };

  const tItens = {
    title: "Itens",
    columns: [
      {
        label: "Produto",
        name: "produtoNome",
      },
      {
        label: "Quantidade",
        name: "quantidade",
      },
      {
        label: "Valor unitário",
        name: "valorFormat",
      },
    ],
    array: itens,
  };

  const fEndereco = {
    title: "Entrega",
    form: {
      CEP: {
        label: "CEP",
        type: "text",
        space: 12,
        value: endereco.CEP,
        readOnly: true,
      },
      logradouro: {
        label: "Logradouro",
        type: "text",
        space: 6,
        value: endereco.logradouro,
        readOnly: true,
      },
      numero: {
        label: "Número",
        type: "text",
        space: 6,
        value: endereco.numero,
        readOnly: true,
      },
      complemento: {
        label: "Complemento",
        type: "text",
        space: 6,
        value: endereco.complemento,
        readOnly: true,
      },
      bairro: {
        label: "Bairro",
        type: "text",
        space: 6,
        value: endereco.bairro,
        readOnly: true,
      },
      municipio: {
        label: "Município",
        type: "text",
        space: 6,
        value: endereco.municipio,
        readOnly: true,
      },
      UF: {
        label: "UF",
        type: "text",
        space: 6,
        value: endereco.UF,
        readOnly: true,
      },
    },
  };

  const tEventos = {
    title: "Eventos",
    newItemAction: () => setInserindoEvento(true),
    // onLineClick: (item) => {
    //   setInserindoEvento(true);
    //   setEvento(item);
    // },
    columns: [
      {
        label: "Título",
        name: "titulo",
      },
      {
        label: "Descrição",
        name: "descricao",
      },
      {
        label: "Registro",
        name: "registro",
      },
    ],
    array: eventos,
  };

  const adicionarEvento = () => {
    let eventoInserir = {};

    if (dadosEventos.tipo === 0) {
      eventoInserir = {
        pedidoId: id,
        titulo: dadosEventos.titulo,
        descricao: dadosEventos.descricao,
        enviarEmail: dadosEventos.enviarEmail,
      };

      comunidade
        .post("admin/pedidos/inserirEvento", eventoInserir)
        .then((res) => {
          notification("success", "Evento inserido com sucesso");
          setInserindoEvento(false);
          carregar();
        })
        .catch((err) => {
          notification("error", "Erro ao inserir evento");
        });
      return;
    }

    if (dadosEventos.tipo === 1) {
      eventoInserir = {
        pedidoId: id,
        descricao: dadosEventos.descricao,
        envio: true,
      };

      confirm({
        title: "Confirma o envio?",
        label:
          'O responsável será notificado via email. É possível adicionar detalhes do envio, como previsão de entrega e código de rastreio, no campo "Descrição"',
        onConfirm: () => {
          comunidade
            .post("admin/pedidos/inserirEvento", eventoInserir)
            .then((res) => {
              notification("success", "Evento inserido");
              setInserindoEvento(false);
              carregar();
            })
            .catch((err) => {
              notification("error", "Erro ao inserir evento");
            });
        },
      });
      return;
    }
    if (dadosEventos.tipo === 2) {
      eventoInserir = {
        pedidoId: id,
        descricao: dadosEventos.descricao,
        cancelamento: true,
      };
      confirm({
        title: "Cancelamento de pedido",
        label:
          "Confirma o cancelamento do pedido? O responsável será notificado e não será possível desfazer esta ação.",
        onConfirm: () => {
          comunidade
            .post("admin/pedidos/inserirEvento", eventoInserir)
            .then((res) => {
              notification("secondary", "Pedido cancelado");
              setInserindoEvento(false);
              carregar();
            })
            .catch((err) => {
              notification("error", "Erro ao cancelar pedido");
            });
        },
      });
      return;
    }
  };

  const salvarDados = (campo, valor) => {
    const dadosAtualizados = { ...dadosEventos };
    dadosAtualizados[campo] = valor;

    setDadosEventos(dadosAtualizados);
  };

  const montarFormEventos = () => {
    const campos = {
      tipo: {
        label: "Tipo",
        type: "select",
        emptyItem: true,
        emptyItemText: "(personalizado)",
        options: [
          {
            value: 1,
            desc: "Envio",
          },
          {
            value: 2,
            desc: "Cancelamento",
          },
        ],
        value: dadosEventos.tipo,
      },
    };

    if (dadosEventos.tipo === 0) {
      campos.titulo = {
        label: "Título",
        type: "text",
        space: 12,
        value: dadosEventos.titulo,
      };
    }
    campos.descricao = {
      label: "Descrição",
      type: "textarea",
      space: 12,
      value: dadosEventos.descricao,
    };

    if (dadosEventos.tipo === 0) {
      campos.enviarEmail = {
        label: "Enviar email para o responsável",
        type: "check",
        space: 12,
        // value: true,
        value: dadosEventos.enviarEmail,
      };
    }

    campos.componente = {
      type: "component",
      space: 12,
      value: (
        <>
          <Stack direction={"row"} spacing={2}>
            <Button
              style={{ color: "white" }}
              variant="contained"
              colo="primary"
              onClick={adicionarEvento}
            >
              Salvar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setEvento({});
                setInserindoEvento(false);
              }}
            >
              Fechar
            </Button>
          </Stack>
        </>
      ),
    };

    return campos;
  };

  const fFormEventos = {
    title: "Novo evento",
    form: montarFormEventos(),
    autoSave: salvarDados,
  };

  const copiarPix = () => {
    navigator.clipboard
      .writeText(pedido.pagamento.iuguPIXCopiaCola)
      .then(() => {
        notification("success", "Código copiado para a área de transferência");
      })
      .catch(() => {
        notification("error", "Erro ao copiar codigo");
      });
  };

  const copiarCodigo = () => {
    navigator.clipboard
      .writeText(pedido.pagamento.iuguBoletoLinhaDigitavel)
      .then(() => {
        notification("success", "Código copiado para a área de transferência");
      })
      .catch(() => {
        notification("error", "Erro ao copiar codigo");
      });
  };
  const baixarArquivo = () => {
    window.open(pedido.pagamento.iuguBoletoPDF);
  };

  return (
    <div>
      <Form formData={fDados} />
      <Form formData={fResponsavel} />
      <ActionTable structure={tItens} />
      <Form formData={fEndereco} />
      {inserindoEvento || evento.id ? (
        <Form formData={fFormEventos} />
      ) : (
        <ActionTable structure={tEventos} />
      )}

      {pedido.situacao === 2 ? (
        <Box
          sx={{
            flexGrow: 1,
            // margin: 2,
            padding: 2,
            background: "white",
            // borderRadius: 2,
          }}
        >
          <Grid container spacing={2}>
            <Grid item md={12} xs={12} style={{ marginBottom: -20 }}>
              <h4>Pagamento</h4>
              <p style={{ fontSize: "1rem" }}>
                Modalidade: {pedido.modalidadePagamento === 3 && "Pix"}{" "}
                {pedido.modalidadePagamento === 1 && "Boleto bancário"}
              </p>
            </Grid>

            <Grid item md={12} xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 2,
                  background: "white",
                  padding: 2,
                  borderRadius: 2,
                  textAlign: "center",
                }}
              >
                {pedido.modalidadePagamento === 1 && (
                  <>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div
                        style={{
                          background: "#efe3b0",
                          width: "50%",
                          padding: 10,
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                          overflow: "hidden",
                          textAlign: "center",
                        }}
                      >
                        {pedido.pagamento.iuguBoletoLinhaDigitavel}
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <Button
                        id="myInput"
                        color="info"
                        variant="text"
                        title="Copiar código pix"
                        onClick={copiarCodigo}
                      >
                        <ContentCopyIcon />
                        copiar código
                      </Button>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <Button
                        color="primary"
                        variant="text"
                        onClick={baixarArquivo}
                      >
                        <ArrowDownwardIcon />
                        Baixar boleto
                      </Button>
                    </div>
                  </>
                )}
                {pedido.modalidadePagamento === 3 && (
                  <>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div
                        style={{
                          background: "#efe3b0",
                          width: "50%",
                          padding: 10,
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                          overflow: "hidden",
                          textAlign: "center",
                        }}
                      >
                        {pedido.pagamento.iuguPIXCopiaCola}
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <Button
                        id="myInput"
                        color="info"
                        variant="text"
                        title="Copiar código pix"
                        onClick={copiarPix}
                      >
                        <ContentCopyIcon />
                        copiar código
                      </Button>
                    </div>
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : null}
    </div>
  );
}
